{
  "dismiss": "Zignoruj"
}